

function Log(message) {
    if (typeof (console) != 'undefined') {
        console.log(message);
    }
}

export namespace UnitedOne {

    declare var jsData: any;

    export class Event<T = void>
    {
        private callbacks: Array<(T) => void>;

        constructor() {
            this.callbacks = new Array<(T) => void>();
        }


        public subscribe(callback: (T) => void): (T) => void {
            if (this.callbacks.indexOf(callback) == -1) {
                this.callbacks.push(callback);
            }

            return callback;
        }

        public unsubscribe(callback: (T) => void): boolean {
            var index = this.callbacks.indexOf(callback);
            if (index != -1) {
                this.callbacks.splice(index, 1);
                return true;
            }

            return false;
        }

        public emit(parameter1?: T) {
            for (var callback of this.callbacks) {
                callback(parameter1);
            }
        }
    }


    export class Logger {

        private type: string;

        constructor(type: any) {
            this.type = type.constructor.name;
        }

        public debug(message?: any, ...optionalParams: any[]) {
            console.log(this.type + ':', message, optionalParams);
        }

        public error(message?: any, ...optionalParams: any[]) {
            console.error(this.type + ':', message, optionalParams);
        }

        public warn(message?: any, ...optionalParams: any[]) {
            console.warn(this.type + ':', message, optionalParams);
        }
    }


    export abstract class DialogViewModelBase {

        public dialogGuid: string = Utils.createGuid();
        public levelOfModal: number;

        public dialogTitle?: KnockoutObservable<string>;
        protected canCloseDialog?: () => boolean;
        protected onAfterClosedDialog?: () => void;
        private isClosed: boolean = false;

        public afterCloseDialog: Event = new Event();

        public buttons: KnockoutObservableArray<DialogButton> = ko.observableArray([]);

       

        constructor(public templateId: string, title?: string) {
            this.dialogTitle = ko.observable(title);
        }

        public close() {
            if (this.canCloseDialog == null || this.canCloseDialog()) {
                var div_container = document.getElementById(this.dialogGuid);


                document.body.removeChild(div_container);
                DialogViewModelBase.numberOfDialogs--;

                this.isClosed = true;

                if (this.onAfterClosedDialog != null) {
                    this.onAfterClosedDialog();
                }

                this.afterCloseDialog.emit();
            }
        }

        public static numberOfDialogs: number = 0;

        public addButton(action: () => void, icon?: string, title?: string, text?: string) {
            this.buttons.push(new DialogButton(action, icon, text, title));
        }

        public show() {

            this.levelOfModal = DialogViewModelBase.numberOfDialogs++;

            

            var template = $('#' + this.templateId);

            if (template.length == 0) {
                alert(`Das Template mit der id '${this.templateId}' existiert nicht.`);
                return;
            }

            // Construc classes string
            var classes = `${this.templateId} ${this.templateId.replace('-template', '')}`;
            if (!Utils.stringIsNullOrWhiteSpace(template.attr('class'))) {
                classes += ` ${template.attr('class')}`;
            }

            let titleHtml = ``;
            if (this.dialogTitle != null) {
                titleHtml = `<div class="dialog-title" data-bind="visible: dialogTitle() && (dialogTitle().length > 0) , html: dialogTitle, event: { 'mousedown': onMouseDown }"></div>`;
            }

            titleHtml = `
                <div class="dialog-heading" data-bind="hoverToggle: 'hover', event: { 'mousedown': onMouseDown }">
                    <span data-bind="visible: dialogTitle() && (dialogTitle().length > 0), html: dialogTitle"></span>
                    <div class="dialog-heading-toolbar animated fadeIn faster">

                        <!-- ko foreach: buttons -->
                        <div class="btn pull-ridght btn-default btn-xs" data-bind="click: action, attr: {'title': title}, hoverToggle: 'hover'"><i class="fa fa-fw" data-bind="visible: showIcon, attr: {'class': 'fa fa-fw fa-' + icon }"></i> <span data-bind="visible: showText, html: text"></span></div>
                        <!-- /ko -->

                        <div class="btn pull-ridght btn-default btn-xs" data-bind="click: close"><i class="fa fa-times fa-fw"></i></div>

                    </div>
                    <div style="clear: both;"></div>
                </div>
            `;


            var div_container = document.createElement("div");
            div_container.setAttribute('class', 'dialog-container');
            div_container.setAttribute('id', this.dialogGuid);

            div_container.innerHTML = `
                                <div class='dialog-content ${classes}'>
                                   
                                    ${titleHtml}
                                    <div class="content-target">
                                        <div data-bind="template: { name: '${this.templateId}', data: $data }"> </div>
                                    </div>
                                </div>`;


            document.body.appendChild(div_container);
            ko.applyBindings(this, div_container);

            document.addEventListener('mouseup', () => { this.onMouseUp(); }, true);
            document.addEventListener('mousemove', (e) => this.onMouseMove(e), true);
            document.addEventListener('keyup', (e) => this.onKeyUp(e), true);

            this.div_container = $('#' + this.dialogGuid + ' .dialog-content')[0];
            //this.div_container.addEventListener('mousedown', (e) => { $(this).css('cursor', 'move'); this.onMouseDown(e); }, true);

            
        }

        private creteGuid(): string {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        }

        private isMouseDown: boolean = false;
        private offsetLeft: number;
        private offsetTop: number;

        private div_container: HTMLElement;

        public onMouseDown(s: any, e: any) {
            this.isMouseDown = true;

            this.offsetLeft = e.clientX - (parseInt(this.div_container.style.left) || 0);
            this.offsetTop = e.clientY - (parseInt(this.div_container.style.top) || 0);
        }

        private lastClientY: number = 0;

        public onMouseMove(e: any) {           
            if (this.isMouseDown) {
                this.div_container.style.left = (e.clientX - this.offsetLeft) + 'px';
                if (this.div_container.offsetTop > 0 || e.clientY > this.lastClientY) {
                    this.lastClientY = e.clientY;
                    this.div_container.style.top = (e.clientY - this.offsetTop) + 'px';
                }
                
            }
        }

        public onMouseUp() {
            this.isMouseDown = false;
        }

        public onKeyUp(e: any) {
            if (e.keyCode == 27) {
                // Check top-most
                if (this.levelOfModal == DialogViewModelBase.numberOfDialogs - 1) {
                    if (!this.isClosed) {
                        this.close();
                    }
                }
            }
        }
    }

    export class DialogButton {

        public showIcon: boolean;
        public showText: boolean;

        constructor(public action: () => void, public icon?: string, public text?: string, public title?: string) {
            this.showIcon = !Utils.stringIsNullOrWhiteSpace(icon);
            this.showText = !Utils.stringIsNullOrWhiteSpace(text);
        }
    }


    export class DialogOldStyleWrapper extends DialogViewModelBase {
        constructor(templateId: string, title: string) {
            super(templateId, title);
        }
    }


    export class Notifier {

        private static isContainerVisible = false;
        private static vm: NotifierViewModel;

        public static showNotification(message: string, type: string, stayDuration?: number) {

            if (!this.isContainerVisible) {
                this.createContainer();
                this.isContainerVisible = true;
            }

            this.vm.items.push(new NotifierNotificationItemViewModel(this.vm, message, type, stayDuration));
        }

        public static createContainer() {

            var div_container = document.createElement("div");
            div_container.setAttribute('class', 'pr-alerts-container');
            div_container.setAttribute('id', 'pr-alerts-container');

            div_container.innerHTML = `
                                <div class='pr-alert-container' id='pr-alert-container'>
                                    <!-- ko foreach: items -->
                                        <div class="pr-alert-item animated" data-bind="attr: {'class': 'pr-alert-item ' + type}">
                                            <div class="pr-alert-item-inner-container">
                                                <div class="pr-alert-item-icon">
                                                    <i class="fa fa-info fa-fw" data-bind="visible: type == 'info'"></i>
                                                    <i class="fa fa-check fa-fw" data-bind="visible: type == 'success'"></i>
                                                    <i class="fa fa-warning fa-fw" data-bind="visible: type == 'warning'"></i>
                                                    <i class="fa fa-ban fa-fw" data-bind="visible: type == 'danger'"></i>
                                                </div>
                                                <div class="pr-alert-item-message" data-bind="html: message"></div>
                                                <div class="pr-alert-item-button" data-bind="hoverToggle: 'hover', click: closeAlert">
                                                    <i class="fa fa-times"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="clear:both;"></div>    
                                    <!-- /ko -->
                                </div>`;

            document.body.appendChild(div_container);

            this.vm = new NotifierViewModel();
            ko.applyBindings(this.vm, div_container);
        }
    }


    class NotifierViewModel {
        public items: KnockoutObservableArray<NotifierNotificationItemViewModel> = ko.observableArray([]);
    }

    class NotifierNotificationItemViewModel {

        constructor(public parent: NotifierViewModel, public message: string, public type: string, public stayDuration?: number) {

            if (this.stayDuration == null) {
                this.stayDuration = 5000;
            }

            window.setTimeout(() => {
                this.closeAlert();
            }, this.stayDuration);
        }

        public closeAlert() {
            this.parent.items.remove(this);
        }
    }

    export class KnockoutComponent {
        public static registerComponent(type: any, identifier: string, templateId?: string, ) {

            if (templateId == null) {
                templateId = identifier + '-template';
            }

            ko.components.register(identifier, {

                viewModel: {
                    createViewModel: (params, componentInfo) => {
                        return new type(params.data, params.raw, params, componentInfo);
                    }
                },
                template: { element: templateId }
            });

        }
    }

    export class Uploader {

        constructor(public callback: (result: UploaderResult) => void) {

        }

        public guid: string = Utils.createGuid();

        public execute() {
            var div_container = document.createElement("div");
            div_container.setAttribute('class', 'upload-container');
            div_container.setAttribute('style', 'display:none;');
            div_container.setAttribute('id', this.guid);

            div_container.innerHTML = `<form id="uploadFileForm-${this.guid}">
                                            <input type="file" name="datafile" id="uploadFileButton-${this.guid}"/>
                                       </form>`;


            document.body.appendChild(div_container);

            $('#uploadFileButton-' + this.guid).click();

            $('#uploadFileButton-' + this.guid).change((e:any) => {
                
                let file = e.target.files[0];

                const xhr = new XMLHttpRequest();
                const formData = new FormData();
                formData.append('datafile', file, file.name);
                xhr.open('POST', '/Utils/UploadFile', true);
                //xhr.setRequestHeader('Content-Type', 'multipart/form-data');
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4 && xhr.status === 200)
                    {
                        var result = JSON.parse(xhr.response);
                        this.callback(new UploaderResult(result.success, result.id, result.originalFilename));
                    }
                };
                xhr.send(formData);
            });
        }
    }

    export class UploaderOld {

        constructor(public callback: (result: UploaderResult) => void) {
            
        }

        public guid: string = Utils.createGuid();

        public execute( ) {
            var div_container = document.createElement("div");
            div_container.setAttribute('class', 'upload-container');
            div_container.setAttribute('style', 'display:none;');
            div_container.setAttribute('id', this.guid);

            div_container.innerHTML = `<form id="uploadFileForm-${this.guid}">
                                            <input type="file" name="datafile" id="uploadFileButton-${this.guid}" data-bind="event: { change: uploadedFileChanged}" />
                                       </form>`;


            document.body.appendChild(div_container);
            ko.applyBindings(this, div_container);

            console.log('bevore click');

            $('#uploadFileButton-' + this.guid).click();
        }

        public uploadedFileChanged() {  
            Utils.uploadFileAsync('uploadFileForm-' + this.guid, (result) => {
                this.callback(new UploaderResult(result.success, result.id, result.originalFilename));
            });
        }
    }

    export class UploaderResult {
        constructor(public success: boolean, public fileId: number, public originalFilename: string) { }
    }

    export class FixedBox {
        public initialOffsetTop: number;
        public initialMarginTop: number;
        public initialMarginBottom: number;
        public elementHeight: number;
        public minimalMarginToBottom: number;
        public minimalMarginToTop: number;

        public windowHeight: number;

        // State variables
        public lastScrollTop: number;
        public lastScrollDirection: ScrollDirection;
        public marginTop: number;

        constructor(public element: JQuery<HTMLElement>, private debugInformationIdentifier?: string) {
            this.initialMarginTop = parseInt(element.css('margin-top'));
            this.initialMarginBottom = parseInt(element.css('margin-bottom'));

            this.minimalMarginToBottom = Math.max(20, this.initialMarginBottom);
            this.minimalMarginToTop = Math.max(10, this.initialMarginTop);

            this.initialOffsetTop = element.offset().top - this.initialMarginTop;

            this.windowHeight = $(window).height();
            this.elementHeight = element.outerHeight();

            this.lastScrollTop = $(document).scrollTop();
            this.lastScrollDirection = ScrollDirection.None;


            $(window).scroll((e) => { this.onScrollChange(); });

            this.marginTop = this.initialMarginTop;
        }



        private onScrollChange(): void {
            // This properties had to be reset all the time
            this.windowHeight = $(window).height();
            this.elementHeight = this.element.outerHeight();

            let scrollTop = $(document).scrollTop();
            var scrollDirection: ScrollDirection = (this.lastScrollTop > scrollTop) ? ScrollDirection.Up : ScrollDirection.Down;
            this.lastScrollTop = scrollTop;

            var spaceToTop = (this.initialOffsetTop + this.marginTop) - scrollTop;
            var spaceToBottom = this.windowHeight - (this.elementHeight + spaceToTop);

            var isBiggerThanViewPort = this.windowHeight < (this.elementHeight);
            isBiggerThanViewPort = this.windowHeight < (this.elementHeight + this.minimalMarginToTop + this.minimalMarginToBottom); // fix

            // Die einzelnen Fälle durchspielen
            let isTopOverlay = spaceToTop < this.minimalMarginToTop;
            let isBottomOverlay = spaceToBottom < this.minimalMarginToBottom;

            let action: string = '[error]';

            if (!isBiggerThanViewPort) {
                if (scrollDirection == ScrollDirection.Up) {
                    // Fall 3
                    if (!isTopOverlay && isBottomOverlay) action = 'dockTop';
                    // Fall 4
                    if (!isTopOverlay && !isBottomOverlay) action = 'dockTop';
                }
                else {
                    // Fall 6
                    if (isTopOverlay && !isBottomOverlay) action = 'dockTop';
                    // Fall 7
                    if (!isTopOverlay && isBottomOverlay) action = 'dockTop';
                    // Fall 8
                    if (!isTopOverlay && !isBottomOverlay) action = 'dockTop';
                }
            }
            else {
                if (scrollDirection == ScrollDirection.Up) {
                    // Fall 9
                    if (isTopOverlay && isBottomOverlay) action = 'hold';
                    // Fall 10
                    if (isTopOverlay && !isBottomOverlay) action = 'hold';
                    // Fall 11
                    if (!isTopOverlay && isBottomOverlay) action = 'dockTop';
                }
                else {
                    // Fall 13
                    if (isTopOverlay && isBottomOverlay) action = 'hold';
                    // Fall 14
                    if (isTopOverlay && !isBottomOverlay) action = 'dockBottom';
                    // Fall 15
                    if (!isTopOverlay && isBottomOverlay) action = 'hold';
                }
            }


            let newMarginTop = this.marginTop;

            if (action == 'dockTop') {
                newMarginTop = (scrollTop - this.initialOffsetTop) + this.minimalMarginToTop;
            }

            if (action == 'dockBottom') {
                newMarginTop = (this.windowHeight + this.lastScrollTop) - (this.elementHeight + this.initialOffsetTop) - this.minimalMarginToBottom;
            }

            // Check if margin is to low
            newMarginTop = Math.max(newMarginTop, this.minimalMarginToTop);

            this.marginTop = newMarginTop;
            this.element.css('margin-top', (this.marginTop) + 'px');

            if (this.debugInformationIdentifier) {
                // Set informations
                let infoString = `das sind die infos: <br/>
          scrollTop ${Math.round(scrollTop)} <br/>
          elementHeight ${Math.round(this.elementHeight)} <br/>
          initialOffsetTop ${this.initialOffsetTop} <br/>
          lastScrollTop ${Math.round(this.lastScrollTop)} <br/>
          spaceToTop ${Math.round(spaceToTop)} <br/>
          spaceToBottom ${Math.round(spaceToBottom)} <br/>
          <br/>
          isBiggerThanViewPort ${isBiggerThanViewPort} <br/>
          isTopOverlay ${isTopOverlay} <br/>
          isBottomOverlay ${isBottomOverlay} <br/>
          action ${action} <br/>
          marginTop ${Math.round(this.marginTop)} <br/>
          `;

                this.element.children(this.debugInformationIdentifier).html(infoString);
            }
        }




        private setElementInformations(scrollTop: number, spaceToTop: number, spaceToBottom: number, action: string, isTopOverlay: boolean, isBottomOverlay: boolean) {

            // Set informations
            let infoString = `das sind die infos: <br/>
              scrollTop ${Math.round(scrollTop)} <br/>
              elementHeight ${Math.round(this.elementHeight)} <br/>
              initialOffsetTop ${this.initialOffsetTop} <br/>
              lastScrollTop ${Math.round(this.lastScrollTop)} <br/>
              spaceToTop ${Math.round(spaceToTop)} <br/>
              spaceToBottom ${Math.round(spaceToBottom)} <br/>
              <br/>
              isTopOverlay ${isTopOverlay} <br/>
              isBottomOverlay ${isBottomOverlay} <br/>
              action ${action} <br/>
              marginTop ${Math.round(this.marginTop)} <br/>
              `;

            this.element.children('.info-string').html(infoString);
        }


    }


    enum ScrollDirection {
        Up, Down, None
    }





    export class Utils {

        public static navigate(url: string, newWindow: boolean = false) {
            if (newWindow)
            {
                window.open(url);
            }
            else {
                window.location.href = url;
            }
            
        }

        

        public static createCookie(name: string, value: any, days: number = 100)
        {
            var expires;

            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            } else {
                expires = "";
            }
            document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
        }

        public static readCookie(name: string)
        {
            var nameEQ = encodeURIComponent(name) + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
            return null;
        }

        public static nl2br(str: string) {
            var breakTag = '<br />';

            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        }

        public static validate(validationEntities: any): boolean {

            var validationModel = (ko as any).validatedObservable(validationEntities);

            if (!validationModel.isValid()) { validationModel.errors.showAllMessages(); return false; }

            return true;
        }

        public static AjaxRequest(url: string, data: any, successHandler: (data: any) => void, extraDelay?:number ) {
            var method = "POST";

            if (data == null) {
                data = {};
            }

            var isDataString = (typeof data == 'string');
            var dataAsString = '';

            if (isDataString) {
                dataAsString = data;
            }
            else {
                dataAsString = JSON.stringify(data);
            }

            return $.ajax({
                type: method,
                contentType: "application/json; charset=utf-8",
                url: url,
                data: dataAsString,
                dataType: "json",
                success: function (data) {
                    if (successHandler != null) {
                        if (extraDelay == null) {
                            successHandler(data);
                        }
                        else {
                            window.setTimeout(x => { successHandler(data) }, extraDelay);
                        }
                    }
                },
                error: function (xhr, status, error) {
                    var message = '%c';
                    message += 'ERROR DURING JSON REQUEST\n'
                    message += 'Code: ' + xhr.status + ' (' + error + ')\n';
                    message += 'For reproduce call: ' + url + Utils.objectToQuerystring(JSON.parse(dataAsString)) + '\n';

                    if (typeof (console) != 'undefined') {
                        console.log(message, 'color: red');
                    }
                }
            });
        } 



        public static uploadFileAsync(formId: string, callback: (result: any) => void, uploadUrl: string = '/Utils/UploadFile/') {
            var form = document.getElementById(formId);
            this.uploadFileAsyncByElement(form, callback, uploadUrl);
        }

        public static uploadFileAsyncByElement(form: HTMLElement, callback: (result:any) => void, uploadUrl: string = '/Utils/UploadFile/') {

            console.warn('this method is deprecated, use Uplaoder instead!');

            var iframe = document.createElement("iframe");
            iframe.setAttribute("id", "upload_iframe");
            iframe.setAttribute("name", "upload_iframe");
            iframe.setAttribute("width", "0");
            iframe.setAttribute("height", "0");
            iframe.setAttribute("border", "0");
            iframe.setAttribute("style", "width: 0; height: 0; border: none;");

            // Add to document...
            form.parentNode.appendChild(iframe);
            window.frames['upload_iframe'].name = "upload_iframe";

            var iframeId = document.getElementById("upload_iframe") as any;

            // Add event...
            var eventHandler = function () {

                if (iframeId.detachEvent) iframeId.detachEvent("onload", eventHandler);
                else iframeId.removeEventListener("load", eventHandler, false);

                var content:string = '';

                // Message from server...
                if (iframeId.contentDocument) {
                    content = iframeId.contentDocument.body.innerHTML;
                } else if (iframeId.contentWindow) {
                    content = iframeId.contentWindow.document.body.innerHTML;
                } else if (iframeId.document) {
                    content = iframeId.document.body.innerHTML;
                }

                console.log(content);

                callback(JSON.parse(content));

                // Del the iframe...
                setTimeout(() => {
                    iframeId.parentNode.removeChild(iframeId);
                }, 250);
            }

            if (iframeId.addEventListener) iframeId.addEventListener("load", eventHandler, true);
            if (iframeId.attachEvent) iframeId.attachEvent("onload", eventHandler);

            // Set properties of form...
            form.setAttribute("target", "upload_iframe");
            form.setAttribute("action", uploadUrl);
            form.setAttribute("method", "post");
            form.setAttribute("enctype", "multipart/form-data");
            form.setAttribute("encoding", "multipart/form-data");
            form.setAttribute("dataType", "json");
            form.setAttribute("contentType", "application/json; charset=utf-8");

            // Submit the form...
            (form as any).submit();
        }

       
        public static downloadAsCsv(data: any, filename: string = 'Export.csv')
        {
         
            var csvContent = "";
            $(data).each(function (index, item) {

                var values = [];
                $(item).each(function (sindex, sitem) {
                    if (!Utils.isDateString(sitem) && Utils.isNumber(sitem)) {
                        values.push(String(sitem).replace('.', ','));
                    }
                    else {
                        values.push(sitem);
                    }
                });

                var dataString = '"' + values.join('";"') + '"';
                csvContent += index < data.length ? dataString + "\n" : dataString;
            });

            csvContent = encodeURI(csvContent);


            var url = '/Utils/CreateFile';
            var form = $('<form action="' + url + '" method="post">' +
                '<input type="text" name="filename" value="' + filename + '" />' +
                '<input type="text" name="content" value="' + csvContent + '" />' +
                '</form>');


            $('body').append(form);


            form.submit();
        }


        public static createGuid(): string {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
        }



        public static objectToQuerystring(obj) {

            if (obj == null) {
                return '';
            }

            var result = Object.keys(obj).reduce(function (str, key, i) {
                var delimiter, val;
                delimiter = (i === 0) ? '?' : '&';
                key = encodeURIComponent(key);
                val = encodeURIComponent(obj[key]);
                if (typeof obj[key] != 'object') {
                    return [str, delimiter, key, '=', val].join('');
                }
                else {
                    return str;
                }

            }, '');


            if (result.length > 0 && result[0] == '&') {
                result = '?' + result.substr(1);
            }

            return result;
        }


        public static generateTemplate(template: string, data: any = null) {

            if (data == undefined) {
                data = "$data";
            }

            return "<div data-bind=\"template: { name: '" + template + "', data: " + data + "}\"></div>"
        }


        public static createComponent(component: string, data: string = null) {

            if (data == undefined) {
                data = "$data";
            }

            return `<${component} params='data: ${data}'></${component}>`;
        }


        public static round(zahl: number, decimal: number = 0) {
            var faktor;
            faktor = Math.pow(10, decimal);
            return (Math.round(zahl * faktor) / faktor);
        }


        public static roundMaxLength(value: number, maxLength: number) {

            var valueWithoutDecimals = Utils.round(value, 0);
            var lenghtWithoutDecimals = Math.abs(valueWithoutDecimals).toString().length;

            return Utils.round(value, Math.max(maxLength - lenghtWithoutDecimals, 0));
        }



        public static formatPercentage(percentage: number, decimal: number = 0): string {
            if (isNaN(percentage)) {
                percentage = 0;
            }
            return Utils.round((percentage * 100), decimal).toString() + '%';
        }

        public static formatMoney(value: number): string {
            return Utils.round(value, 2).toString() + ' €';
        }

        public static formatNumber(value: number): string {
            if (value == null) {
                return null;
            }

            return value.toLocaleString('de-DE');
        }

        public static formatNumberToReadableString(value?: number): string {
            if (value == null) {
                return '-';
            }

            var appendix = '';

            if (value > 10000000000) {
                value = Utils.round(value / 1000000000, 0);
                appendix = ' Mrd.';
            }
            else if (value > 1000000000) {
                value = Utils.round(value / 1000000000, 1);
                appendix = ' Mrd.';
            }
            else if (value > 10000000) {
                value = Utils.round(value / 1000000, 0);
                appendix = ' Mio.';
            }
            else if (value > 1000000) {
                value = Utils.round(value / 1000000, 1);
                appendix = ' Mio.';
            }
            else if (value > 10000) {
                value = Utils.round(value / 1000, 0);
                appendix = ' Tsd.';
            }
            else if (value > 100) {
                value = Utils.round(value, 1);
            }
            else {
                value = Utils.round(value, 2);
            }

            return value + appendix;
        }

        public static stringIsNullOrWhiteSpace = function (value: String) {            
            return (typeof value === 'undefined' || value == null) || value.replace(/\s/g, '').length < 1;
        };

        public static shv = function (value: String) {
            return Utils.stringIsNullOrWhiteSpace(value);
        };


        public static stringIsNullOrEmpty = function (value: any) {
            return (typeof value === 'undefined' || value == null) || value.length < 1;
        };


        public static escapeEmptyString = function (value: any, escape: any) {
            return Utils.stringIsNullOrWhiteSpace(value) ? escape : value;
        };

        public static objectToUrlQuery(parameters: any, addQuestionmark: boolean = true) {

            var result = Object.keys(parameters).reduce(function (str, key, i) {
                var delimiter, val;
                delimiter = (i === 0) ? '?' : '&';
                key = encodeURIComponent(key);
                val = encodeURIComponent(parameters[key]);
                if (typeof parameters[key] != 'object') {
                    return [str, delimiter, key, '=', val].join('');
                }
                else {
                    return str;
                }

            }, '');

            if (result.length > 0 && result[0] == '&') {
                result = '?' + result.substr(1);
            }

            if (!addQuestionmark && result.length > 0 && result[0] == '?') {
                result = result.substr(1);
            }

            return result;
        }

        public static urlQueryToObject(query: string) : any {
            if (Utils.stringIsNullOrWhiteSpace(query)) {
                return {};
            }

            var parsedObject = {};          
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                parsedObject[pair[0]] = decodeURIComponent(pair[1]);
            }

            return parsedObject;
        }


        public static isNumber(obj: any): boolean {
            if (obj == null) {
                return false;
            }
            return !isNaN(parseFloat(obj));
        }

        public static isDateString(obj: any) {
            if (obj == null)
            {
                return false;
            }
            const date = new Date(obj.toString());
            return !isNaN(date.getTime());
        }

        public static log(n: number, base?:number): number{
            return Math.log(n) / (base ? Math.log(base) : 1);
        }

        public static calculateKeywordVolumePercentage(volume: number): number {
            var result = Utils.log(0.1 * volume, 1.13);
            if (result < 1.0) {
                result = 1.0;
            }
            return result / 100;
        }

        public static calculateKeywordCpcPercentage(cpc: number): number {
            if (cpc == null) cpc = 0.0;
            if (cpc > 5.0) cpc = 5.0;
            return cpc / 5.0;
        }

        public static calculatePiVolumePercentage(pi: number): number {
            var result = Utils.log(0.2 * pi, 1.13);
            if (result < 1.0) {
                result = 1.0;
            }

            return result / 100;
        }

        public static calculateValueVolumePercentage(value: number): number {
            var result = Utils.log(value, 1.13);
            if (result < 1.0) {
                result = 1.0;
            }

            return result / 100;
        }


        private static documentReadyCallbacks: Array<{ callback: () => void, order: number }> = [];
        public static registerDocumentReady(callback: () => void, order: number = 0) {
            this.documentReadyCallbacks.push({
                order: order,
                callback: callback
            });
        }
        public static executeDocumentReadyCallbacks() {
            var sortedCallbacks = this.documentReadyCallbacks.sort((a, b) => a.order - b.order);
            for (var callback of sortedCallbacks) {
                callback.callback();
            }
        }


        public static setPageTitle(title: string) {
            if (document.title != title) {
                document.title = title;
            }
        }

        public static setPageDescription(description: string) {
            $('meta[name="description"]').attr("content", description);
        }

        public static setPageTitleAndDescription(title: string, description: string) {
            Utils.setPageTitle(title);
            Utils.setPageDescription(description);
        }


        public static isValidIban(value: string): boolean {
            var CODE_LENGTHS = {
                AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
                CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
                FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
                HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
                LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
                MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
                RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26
            };
            var iban = String(value).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
                code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
                digits;
            // check syntax and length
            if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
                return false;
            }
            // rearrange country code and check digits, and convert chars to ints
            digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, letter => {
                return (letter.charCodeAt(0) - 55).toString();
            });
            // final check
            return Utils.mod97(digits) === 1;
        };

        private static mod97(value: string)
        {
            var checksum:any = value.slice(0, 2), fragment;
            for (var offset = 2; offset < value.length; offset += 7) {
                fragment = String(checksum) + value.substring(offset, offset + 7);
                checksum = parseInt(fragment, 10) % 97;
            }
            return checksum;
        }

        public static isValidBic(value: string): boolean {
            value = value.replace(/\s/g, '');
            return /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(value.toUpperCase());
        };

        public static isEmailValid(value: string): boolean {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        }

        public static isUrlValid(value: string): boolean {
            const re = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
            return re.test(String(value).toLowerCase());
        }


        public static replaceAll(param: string, oldValue: string, newValue: string): string {
            return param.split(oldValue).join(newValue);
        };


        public static showDialog(templateId: string, title: string, vm: any) {
            var dvm = new DialogOldStyleWrapper(templateId, title);
            dvm.show();
        }


        public static getDomainOfUrl(url: string): string {
            var a = document.createElement('a');
            a.href = url;
            return a.hostname;
        }

        public static isLoadedInIframe(): boolean {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        }


        public static waitForElement(identifier: string, callback: () => void) {

            


            if ($(identifier).length) {

                window.setTimeout(function () {
                    callback();
                }, 10);
            }
            else {
                var interval = window.setInterval(() => {
                    if ($(identifier).length) {
                        window.clearInterval(interval);
                        callback();
                    }
                }, 10);
            }
        }


        public static copyTextToClipboard(text: string) {
            var textArea = document.createElement("textarea") as any;

            //
            // *** This styling is an extra step which is likely not required. ***
            //
            // Why is it here? To ensure:
            // 1. the element is able to have focus and selection.
            // 2. if element was to flash render it has minimal visual impact.
            // 3. less flakyness with selection and copying which **might** occur if
            //    the textarea element is not visible.
            //
            // The likelihood is the element won't even render, not even a flash,
            // so some of these are just precautions. However in IE the element
            // is visible whilst the popup box asking the user for permission for
            // the web page to copy to the clipboard.
            //

            // Place in top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.value = text;

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                let successful = document.execCommand('copy');
                let msg = successful ? 'successful' : 'unsuccessful';
            } catch (err) {
            }

            document.body.removeChild(textArea);
        }

        

        public static downloadTextAsFile(text: string, filename: string) {

            var data = { content: text, filename: filename };

            Utils.AjaxRequest('/Utils/CreateFileDownload/', data, data => {
                console.log(data);

                Utils.navigate('/Utils/DownloadFile/?guid=' + data.guid);

            });
        }


        public static validateKnockout(parentVM: any, showValidationMessages: boolean = true): boolean {

            var errors = (ko as any).validation.group(parentVM);

            if (!parentVM.isValid()) {
                if (showValidationMessages) {
                    errors.showAllMessages();
                }
                return false;
            }

            return true;
        }


        public static checkPasswordStrength(password: string)
        {
            var containsDigits = /\d/.test(password);
            var containsLower = /[a-z]/.test(password);
            var containsUpper = /[A-Z]/.test(password);
            var containsNonWords = !/^[a-zA-Z0-9]$/.test(password);
            var whiteSpaceFree = !/\s/.test(password);
            var lengthOk = password.length > 8;

            return containsDigits && containsLower && containsUpper && containsNonWords && whiteSpaceFree && lengthOk;
        }


        public static pluralize(value: number, singleUnit: string, multiplier: string) : string {
            if (value == 1) {
                return value.toString() + ' ' + singleUnit;
            }
            else {
                return value.toString() + ' ' + singleUnit + multiplier;
            }
        }

        public static pluralize2(value: number, singleUnit: string, pluralUnit: string): string {
            if (value == 1) {
                return value.toString() + ' ' + singleUnit;
            }
            else {
                return value.toString() + ' ' + pluralUnit;
            }
        }

        public static createHash(str: string):number {
            var hash = 0, i, chr, len;
            if (str.length === 0) return hash;
            for (i = 0, len = str.length; i < len; i++) {
                chr = str.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        }

        public static getDifferenceInDays(a: Date, b: Date)
        {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        }

        public static hexToRgb(hex: string) {

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        }

    }

    $(document).ready(function () {
        Utils.executeDocumentReadyCallbacks();
    });


    export class Timer {

        private intervallHandler?: number;
        private timeoutHandler?: number;

        constructor(public callback: Function, public dueTime: number, public period?: number) {
            this.change(dueTime, period);
        }

        public stop() {
            if (this.intervallHandler) window.clearInterval(this.intervallHandler);
            if (this.timeoutHandler) window.clearTimeout(this.intervallHandler);
        }

        public change(dueTime: number, period?: number) {

            this.dueTime = dueTime;
            this.period = period;

            this.stop();

            this.timeoutHandler = window.setTimeout(() => {
                this.callback();
                if (this.period) {
                    this.intervallHandler = window.setInterval(() => {
                        this.callback();
                    }, this.period);
                }
            }, dueTime);
        }
    }

    export class StateHandler {

        private isHistoryApiSupported: boolean;

        public stateChange: Event;

        constructor(private defaultParameters: any) {
            this.isHistoryApiSupported = !!(window.history && history.pushState);

            this.stateChange = new Event();

            if (this.isHistoryApiSupported) {
                window.onpopstate = (event) => {
                    this.stateChange.emit(event.state);
                };
            }
        }

        public updateStateWithPartialParameters(parameters: any) {
            var oldParameters = this.getParameterObjectFromUrl();
            var newParameters = $.extend({}, oldParameters, parameters);
            this.updateState(newParameters);
        }

        public updateState(parameters: any) {


            var currentUrl = window.location.href;

            var queryString = '';
            var hashString = '';
            var parts = currentUrl.split("?");
            var baseUrl = parts[0];
            if (parts.length > 1) {
                var parts2 = parts[1].split("#");
                queryString = '?' + parts2[0];
            }
            parts = currentUrl.split("#");
            if (parts.length > 1) {
                hashString = '#' + parts[1];
            }

            var newQueryString = this.parameterToQueryString(parameters);

            var newUrl = baseUrl + newQueryString + hashString;

            if (queryString != newQueryString && !Utils.isLoadedInIframe()) {

                try {
                    window.history.pushState(parameters, '', newUrl);
                }
                catch (e) {
                    console.warn('Error during push state', e);
                }
            }
        }

        

        public getParameterObjectFromUrl() {
            var search = location.search.substring(1);

            if (search.length == 0) {
                return this.defaultParameters;
            }

            var parameters = Utils.urlQueryToObject(search);

            //var parameters = JSON.parse('{"' + decodeURIComponent(decodeURI(search)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

            return $.extend({}, this.defaultParameters, parameters);
        }

        public removeDefaults(parameters: any, defaultparameters: any) {
            var result = {};

            for (var p in parameters) {
                if (!defaultparameters.hasOwnProperty(p) || (parameters[p] != defaultparameters[p])) {
                    result[p] = parameters[p];
                }
            }

            return result;
        }

        public parameterToQueryString(parameters: any): string {
            var result = Object.keys(parameters).reduce(function (str, key, i) {
                var delimiter, val;
                delimiter = (i === 0) ? '?' : '&';
                key = encodeURIComponent(key);
                val = encodeURIComponent(parameters[key]);
                if (typeof parameters[key] != 'object') {
                    return [str, delimiter, key, '=', val].join('');
                }
                else {
                    return str;
                }

            }, '');

            if (result.length > 0 && result[0] == '&') {
                result = '?' + result.substr(1);
            }

            return result;
        }


    }



    


    export class DataTable<T = any> {

        public logger: Logger;

        public columns: Array<DataTableColumn<T>>;
        public currentData: Array<T>;

        public isInitialized: boolean = false;

        public datatable: any;
        public dtvm: any;

        public isBusy: KnockoutObservable<boolean> = ko.observable(false);
        public noEntries: KnockoutObservable<boolean> = ko.observable(false);

        public orderChanged: Event<any> = new Event<any>();

        

        constructor(public definition: DataTableDefinition<T>) {


            // -------------- Set some defaults ---------------- //
            if (!this.definition.container) { this.definition.container = 'datatable'; }
            if (!this.definition.deferInit) { this.definition.deferInit = true; }

            this.logger = new Logger(this);

            if (!this.definition.deferInit) {
                this.init();
            }
        }

        public enhanceDataTableColumsWithViewConfig(viewConfig: any, keepTitle: boolean = false) {

            if (this.isInitialized) {
                this.logger.error('enhanceDataTableColumsWithViewConfig(...) had to be called bevore init()');
            }

            var orderColumnId = viewConfig.orderby.selectedColumnValue();
            var orderDirection = viewConfig.orderby.selectedDirectionValue();

            var selectedColumns = viewConfig.columnSelection.selectedValues();


            for (var column of this.definition.columns) {

                var vc_column = viewConfig.columns.first(x => x.id == column.id);

                if (vc_column) {
                    if (!keepTitle) {
                        column.title = vc_column.title_short;
                    }
                    
                    column.description = vc_column.description;
                    column.sortable = vc_column.isorderable;

                    if (orderColumnId == column.id) {
                        column.defaultOrder = orderDirection;
                        
                    }

                    column.visible = selectedColumns.contains(column.id);
                }
            }
        }

        public setColumVisibilityByViewConfigValues(columnSelectorFilter: any) {
       
            for (var column of columnSelectorFilter.columnChoices()) {

                this.setColumnVisibility(column.id, column.isSelected());
            }
        }

        private lastOrderValues: any = null;

        private firstLoad: boolean = true;
        private isOffsetSet: boolean = false;
        private lastWidth: number = null;
        private lastWidthDeferTimeout: any = null;

        public init() {

            this.isInitialized = true;

            // Build the column objects
            this.columns = [];
            for (var column of this.definition.columns) {
                this.columns.push(new DataTableColumn<T>(column));
            }


            // -------------- Temporär wird noch das alte Framework verwendet ---------------- //

          

            var options: any = {
                identifier: '#' + this.definition.container,
                enableColumnSettings: false,
                showLengthChanging: this.definition.showLengthChanging != null ? this.definition.showLengthChanging : true,
                showPagination: this.definition.showPagination != null ? this.definition.showPagination : true,
                pageLength: this.definition.pageLength != null ? this.definition.pageLength : 50,
                stateSave: this.definition.stateSave != null ? this.definition.stateSave : false,
                highlight: this.definition.highlight != null ? this.definition.highlight : null,
                scrollTopAfterPaginate: this.definition.scrollTopAfterPaginate != null ? this.definition.scrollTopAfterPaginate : true,
                isBusy: this.definition.isBusy,
                lengthMenu: [[], []],
                rawAdditionalOptions: this.definition.rawAdditionalOptions != null ? this.definition.rawAdditionalOptions : {}
            };

            var defaultLengthMenu = [25, 50, 100, 200];

            // Check if the selected pageLengh is in the menu
            if (!defaultLengthMenu.contains(this.definition.pageLength)) {
                defaultLengthMenu.push(this.definition.pageLength);
            }

            defaultLengthMenu.sort((a, b) => a - b);

            for (let item of defaultLengthMenu) {
                options.lengthMenu[0].push(item);
                options.lengthMenu[1].push(item);
            }

 
            if (this.definition.ajax != null) {
                options.ajax = (request_data, callback) => {

                    if (!this.firstLoad) {

                        this.isBusy(true);

                        var orderColumn = this.columns[request_data.order[0].column];

                        request_data.orderColumnId = orderColumn.definition.id;
                        request_data.orderColumnDirection = request_data.order[0].dir;

                        var vcd = this.definition.ajax.before(request_data);

                        Utils.AjaxRequest(this.definition.ajax.url, vcd, data => {


                            var viewModels = new Array();
                            $(data.items).each((index, item) => {
                                var ivm = this.definition.ajax.itemConstructor(item);
                                viewModels.push(ivm);
                            });

                            this.currentData = viewModels;

                            var datatableData = {
                                iTotalRecords: data.total,
                                iTotalDisplayRecords: data.total,
                                sEcho: request_data.draw,
                                aaData: viewModels
                            };

                            callback(datatableData);

                            this.isBusy(false);
                            this.noEntries(data.total == 0);

                            if (this.definition.ajax.after != null) {
                                this.definition.ajax.after(data);
                            }
                        });
                    }
                    this.firstLoad = false;
                };
            }

            if (this.definition.collection != null) {
                options.collection = this.definition.collection;
            }

            if (this.definition.rowCallback != null) {
                options.rowCallback = this.definition.rowCallback;
            }
       

            var columns = [];
            for (var c of this.columns) {
                columns.push(c);
            }

          

            var global: any = window;
          
            this.dtvm = new global.CreateDatatable(options, columns);
            this.datatable = this.dtvm.datatable;

            this.lastOrderValues = this.getOrder();
            this.datatable.on('order.dt', () => {
               this.onMayBeOrderChanged();
            });

            if (this.definition.ajax != null && this.definition.offset != null) {
                this.isBusy.subscribe(x => {
                    if (!this.isOffsetSet && !this.isBusy()) {
                        var pageInfo = this.datatable.page.info();
                        var newPage = Math.floor(this.definition.offset / pageInfo.length);

                        if (newPage != pageInfo.page && newPage < pageInfo.pages) {
                            this.datatable.page(newPage).draw(false);
                        }

                        this.isOffsetSet = true;
                    }
                    
                });
            }

            // Size change watcher
            if (this.definition.autoResize) {

                window.setInterval(() => {
                    let newWidth = $(options.identifier).parent().width();
                    
                    if (this.lastWidth != null && this.lastWidth != newWidth) {
                        window.clearTimeout(this.lastWidthDeferTimeout);
                        this.lastWidthDeferTimeout = window.setTimeout(() => {
                            console.log('dt width changed');
                            this.adjustSize();
                        }, 100);
                    }

                    this.lastWidth = newWidth;
                }, 10);
            }



        }

        public refresh() {
            this.datatable.draw();
        }

        public adjustSize() {
            window.setTimeout(() => this.datatable.columns.adjust(), 1); 
        }


        public getOrder() {

            var order = this.datatable.order()[0];
            var column = this.definition.columns[order[0]];

            return { id: column.id, dir: order[1] };
        }

        public setOrder(id: string, dir: string) {
            var column = this.definition.columns.first(x => x.id == id);
            var index = this.definition.columns.indexOf(column);

            if (index < 0) {
                this.logger.error('setOrderColumn: Cannot find colum with id ' + id);
                return;
            }

            this.datatable.order([index, dir]);
            this.datatable.draw();
        }

        public onMayBeOrderChanged() {

            // Precheck
            var order = this.datatable.order()[0];
            if (order == null) {
                return;
            }

            var newOrderValues = this.getOrder();
            if (this.lastOrderValues.id != newOrderValues.id || this.lastOrderValues.dir != newOrderValues.dir) {
                this.lastOrderValues = newOrderValues;

                this.orderChanged.emit(newOrderValues);
            }
        }

        public setColumnVisibility(id: string, value: boolean) {
            var column = this.columns.first(x => x.id == id);
            var index = this.columns.indexOf(column);

            if (index != -1) {
                this.datatable.column(index).visible(value);
            }
        }

        public hideAllColumns() {
            for (var i = 0; i < this.columns.length; i++) {
                this.datatable.column(i).visible(false);
            }
        }

        public setColumnTitle(id: string, value: string) {
            var column = this.columns.first(x => x.id == id);
            var index = this.columns.indexOf(column);

            if (index != -1) {
                var header = this.datatable.column(index).header();
                $(header).html(value);
            }
        }


        public setIsBusy(value: boolean): void {
            if (this.definition.collection != null || this.definition.ajax == null) {
                this.datatable.processing(value);
            }
            else
            {
                console.warn('You cannot set the busy state of a datable where ajax is definied or no collection is defined.');
            }
        }

      

        public static columnDefinitions = {
            selection: { id: 'selection', title: '', width: "5px", renderComponent: 'selection-column-component', renderComponentData: 'selection' },
            keywordandurl: { id: 'keywordandurl', title: 'Keyword und Url', width: "auto", renderComponent: 'keyword-and-url-column', renderComponentData: 'item' },
            keyword: { id: 'keyword', title: 'Keyword', width: "auto", renderComponent: 'keyword-column', renderComponentData: 'item' },
            keywordFx: () => {
                return { id: 'keyword', title: 'Keyword', width: "auto", renderComponent: 'keyword-column', renderComponentData: 'item', renderSort: vm => vm.item.keyword }
            },
            url: { id: 'url', title: 'Url', width: "auto", renderComponent: 'url-column', renderComponentData: 'item' },
            keywordspecification: { id: 'keywordspecification', width: "60px", renderComponent: 'keyword-specification-column', renderComponentData: 'item' },
            keywordspecificationFx: () => {
                return { id: 'keywordspecification', width: "60px", renderComponent: 'keyword-specification-column', renderComponentData: 'item' }
            },
            keywordlocation: { id: 'keywordlocation', width: "100px", renderComponent: 'keyword-location-column', renderComponentData: 'item' },
            keywordspecificationinline: { id: 'keywordspecification', width: "60px", renderComponent: 'keyword-specification-inline-column', renderComponentData: 'item' },
            keywordspecificationinlineFx: () => { return { id: 'keywordspecification', width: "60px", renderComponent: 'keyword-specification-inline-column', renderComponentData: 'item' } },
            searchvolume: { id: 'searchvolume', title: 'Vol.', width: "35px", renderComponent: 'searchvolume-column', renderComponentData: 'item', renderSort: vm => vm.item.searchvolume, sortable: true },
            searchvolumeFx: () => {
                return { id: 'searchvolume', title: 'Vol.', width: "35px", renderComponent: 'searchvolume-column', renderComponentData: 'item', renderSort: vm => vm.item.searchvolume, sortable: true }
            },
            competition: { id: 'competition', title: 'Wett.', width: "35px", renderComponent: 'competition-column', renderComponentData: 'item', renderSort: vm => vm.item.competition, sortable: true },
            competitionFx: () => {
                return { id: 'competition', title: 'Wett.', width: "35px", renderComponent: 'competition-column', renderComponentData: 'item', renderSort: vm => vm.item.competition, sortable: true }
            },
            cpc: { id: 'cpc', title: 'CPC', width: "35px", renderComponent: 'cpc-column', renderComponentData: 'item', renderSort: vm => vm.item.cpc, sortable: true },
            cpcFx: () => {
                return { id: 'cpc', title: 'CPC', width: "35px", renderComponent: 'cpc-column', renderComponentData: 'item', renderSort: vm => vm.item.cpc, sortable: true }
            },
            psi: { id: 'psi', title: 'PSI', width: "35px", renderComponent: 'psi-column', renderComponentData: 'item', renderSort: vm => vm.item.psi, sortable: true },
            value: { id: 'value', title: 'Wert', width: "35px", renderComponent: 'value-column', renderComponentData: 'item', renderSort: vm => vm.item.value, sortable: true }
        };


        public static columnDefinitionsContentSuite = {
            keywordandurl: { id: 'keywordandurl', title: 'Keyword und Url', width: "auto", renderComponent: 'cs-keyword-and-url-column', renderComponentData: 'item' },
            keyword: { id: 'keyword', title: 'Keyword', width: "auto", renderComponent: 'cs-keyword-column', renderComponentData: 'item' },
            keywordFx: () => {
                return { id: 'keyword', title: 'Keyword', width: "auto", renderComponent: 'cs-keyword-column', renderComponentData: 'item' }
            },
            url: { id: 'url', title: 'Url', width: "auto", renderComponent: 'url-column', renderComponentData: 'item' },
            keywordandurlsc: { id: 'keywordandurl', title: 'Keyword und Url', width: "auto", renderComponent: 'cs-keyword-and-url-sc-column', renderComponentData: 'item' },
        };

        public static columnDefinitionsSearchConsole = {
            selection: { id: 'selection', title: '', width: "5px", renderComponent: 'selection-column-component', renderComponentData: 'selection' },
            keywordandurl: { id: 'keywordandurl', title: 'Keyword und Url', width: "auto", renderComponent: 'keyword-and-url-sc-column', renderComponentData: 'item' },
            keyword: { id: 'keyword', title: 'Keyword', width: "auto", renderComponent: 'keyword-sc-column', renderComponentData: 'item' },
            url: { id: 'url', title: 'Url', width: "auto", renderComponent: 'url-sc-column', renderComponentData: 'item' },
            position: { id: 'position', title: 'Position', width: "35px", renderComponent: 'position-sc-column', renderComponentData: 'item' },
            page: { id: 'page', title: 'Seite', width: "35px", renderComponent: 'page-sc-column', renderComponentData: 'item' },
            clicks: { id: 'clicks', title: 'Clicks', width: "35px", renderComponent: 'clicks-sc-column', renderComponentData: 'item' },
            impressions: { id: 'impressions', title: 'Impressions', width: "35px", renderComponent: 'impressions-sc-column', renderComponentData: 'item' },
            ctr: { id: 'ctr', title: 'CTR', width: "35px", renderComponent: 'ctr-sc-column', renderComponentData: 'item' }
        };
    }

    

    export class DataTableSelectionColumn {

        public isSelected: KnockoutObservable<boolean> = ko.observable(false);

        public toggleSelection() {
            this.isSelected(!this.isSelected());
        }

        public render() {
            var guid = Utils.createGuid();

            Utils.waitForElement('#' + guid, () => {
                var toggler = $('#' + guid)[0];

                ko.cleanNode(toggler);
                ko.applyBindings(this, toggler);
            });

            return { id: 'selection', width: '1px', renderTemplate: 'select-column-template', sortable: false, title: `<div class="selection-col-header" id="${guid}" data-bind="click: toggleSelection"><i class="fa fa-fw fa-check-square-o" data-bind="visible: isSelected()"></i><i class="fa fa-fw fa-square-o" data-bind="visible: !isSelected()"></i></div>` };
        }
    }
    

    export class DataTableAjaxRequestParameters {
        public start: string;
        public length: string;
        public orderColumnId: string;
        public orderColumnDirection: string;
    }

    export class DataTableDefinition<T> {

        public columns: Array<DataTableColumnDefinition<T>>;
        public container?: string;
        public ajax?: {
            url: string,
            before: (parameters: DataTableAjaxRequestParameters) => any,
            itemConstructor: (item: any) => T,
            after?: (data: any) => void,
        };
        public deferInit?: boolean;
        public collection?: any;
        public showLengthChanging?: boolean;
        public offset?: number;
        public showPagination?: boolean;
        public stateSave?: boolean;
        public pageLength?: number;
        public rowCallback?: (row: any, vm: any) => void;
        public highlight?: (vm: T) => boolean;
        public scrollTopAfterPaginate?: boolean;
        public isBusy?: KnockoutObservable<boolean>;
        public autoResize?: boolean;

        public rawAdditionalOptions?: any;
    }


    export class DataTableColumn<T> {

        public id: string;
        public title: string;
        public description: string;
        public selectorTitle: string;
        public sortable: boolean;
        public defaultOrder?: string;
        public width: string;
        public render: (item: T) => string;
        public renderSort: (item: T) => number;
        public className: string;
        public classNameHeader: string;
        public visible: boolean;
        

        constructor(public definition: DataTableColumnDefinition<T>) {


            this.id = definition.id == null ? 'none' : definition.id;
            this.title = (definition.title != null) ? definition.title : '';
            this.description = (definition.description != null) ? definition.description : '';
            this.selectorTitle = (definition.selectorTitle != null) ? definition.selectorTitle : this.title;
            this.sortable = (definition.sortable != null) ? definition.sortable : false;
            this.width = (definition.width != null) ? definition.width : 'auto';
            this.className = (Utils.stringIsNullOrWhiteSpace(definition.id) ? '' : (definition.id + ' ')) + ((definition.className != null) ? definition.className : '');
            this.classNameHeader = (Utils.stringIsNullOrWhiteSpace(definition.id) ? '' : (definition.id + ' ')) + ((definition.classNameHeader != null) ? definition.classNameHeader : '');
            this.visible = (definition.visible != null) ? definition.visible : true;
            
            

            this.defaultOrder = definition.defaultOrder;

            if (definition.renderTemplate != null) {
                this.render = (vm) => Utils.generateTemplate(definition.renderTemplate, (definition.renderTemplateData != null) ? definition.renderTemplateData : null);
            }
            else if (definition.renderComponent != null) {
                this.render = (vm) => Utils.createComponent(definition.renderComponent, (definition.renderComponentData != null) ? definition.renderComponentData : null);
            }
            else {
                this.render = (vm) => definition.render(vm);
            }

            if (definition.renderSort != null) {
                this.renderSort = (vm) => definition.renderSort(vm);
            }
            else {
                this.renderSort = vm => Number(this.render(vm));
            }
        }
    }

    export class DataTableColumnDefinition<T> {
        public title?: string;
        public description?: string;
        public selectorTitle?: string;
        public id?: string;
        public width?: string;
        public render?: (item: T) => string;
        public renderTemplate?: string;
        public renderTemplateData?: string;
        public renderComponent?: string;
        public renderComponentData?: string;
        public renderSort?: (item: T) => number;
        public sortable?: boolean;
        public defaultOrder?: string;
        public className?: string;
        public classNameHeader?: string;
        public visible?: boolean;
    }


    

    export class ChartDefinition {
        public identifier: string;

        public xAxisGridLineWidth?: number;
        public xAxisTickInterval?: number;
        public xAxisVisible?: boolean;

        public yAxisTitle?: string;
        public yAxisReversed?: boolean;
        public yAxisVisible?: boolean;
        public yAxisMin?: number;

        public showLegend?: boolean;
        public legendFontSize?: string;
        public showMarker?: boolean;

        public series?: Array<ChartSeriesDefinition>;
        public categories?: Array<string>;

        public clickhandler?: (item: any) => void;

        public enableStacking?: boolean;
    }

    export class UpdateChartDefinition {
       
        public series?: Array<ChartSeriesDefinition>;
        public categories?: any;
    }

    export class ChartSeriesDefinition {
        public name: string;
        public data: any;
        public visible?: boolean;
        public colorByPoint?: boolean;
    }
    




    export class Chart {

        public logger: Logger;

        public chart: any;

        public stackArea: boolean = false;
        private isInitialized: boolean = false;

        constructor(public definition: ChartDefinition, public type: string) {
            this.logger = new Logger(this);

        }

        public update(definition: UpdateChartDefinition) {

            var updateObject : any = {};

            if (definition.series) {
                updateObject.series = definition.series;
               
                while (this.chart.series.length > 0) {
                    this.chart.series[0].remove(false);
                }

                for (var series of definition.series) {
                    let seriesCopy = series;
                    this.chart.addSeries(seriesCopy, false);
                    
                    //this.chart.addSeries({
                    //    name: series.name,
                    //    data: series.data,
                    //    visible: series.visible != null ? series.visible : true
                    //}, false);
                }
            }

            if (definition.categories) {
                this.chart.xAxis[0].setCategories(definition.categories);
            }
            
            this.chart.redraw();
        }

        public initIfNecessary() {
            if (!this.isInitialized) {
                this.init();
            }
        }

        public init(): void {
            var global: any = window;

            if ($(this.definition.identifier).length == 0) {
                this.logger.error(`Element with identifier '${this.definition.identifier}' does not exits.`);
                return;
            }

            

            this.chart = global.Highcharts.chart({
                chart: {
                    renderTo: $(this.definition.identifier)[0],
                    type: this.type
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: this.definition.categories ? this.definition.categories : [],
                    tickInterval: this.definition.xAxisTickInterval,
                    gridLineWidth: this.definition.xAxisGridLineWidth,
                    visible: this.definition.xAxisVisible != null ? this.definition.xAxisVisible : true
                },
                yAxis: {
                    min: this.definition.yAxisMin != null ? this.definition.yAxisMin : 0,
                    visible: this.definition.yAxisVisible != null ? this.definition.yAxisVisible : true,
                    reversed: this.definition.yAxisReversed ? this.definition.yAxisReversed : false,
                    title: {
                        text: this.definition.yAxisTitle ? this.definition.yAxisTitle : ''
                    },
                    allowDecimals: false
                },
                tooltip: {
                    headerFormat: '{point.key}<br/>',
                    pointFormat: '{series.name}: <b>{point.y}</b><br/>',
                    footerFormat: '',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    area: {
                        stacking: this.stackArea ? 'noraml' : null
                    },
                    column: {
                        pointPadding: 0.2,
                        borderWidth: 0,
                        stacking: this.definition.enableStacking ? 'normal' : null,
                        cursor: ((this.definition.clickhandler != null) ? 'pointer' : 'default'),
                        point: {
                            events: {
                                click: (e) => {
                                    console.log(e.point.options);
                                    if (this.definition.clickhandler != null) {
                                        this.definition.clickhandler(e);
                                    }
                                }
                            }
                        }
                    },
                    series: {
                        marker: {
                            enabled: this.definition.showMarker != null ? this.definition.showMarker : true
                        }
                    }
                },
                series: this.definition.series ? this.definition.series : [],
                legend: {
                    enabled: this.definition.showLegend != null ? this.definition.showLegend : false,
                    itemStyle: {
                        fontSize: this.definition.legendFontSize != null ? this.definition.legendFontSize : '12px'
                    }
                },
                exporting: {
                    buttons: {
                        contextButton: {
                            enabled: false
                        }
                    }
                },
                credits: {
                    enabled: false
                }
            });

            this.isInitialized = true;

            console.log(this.chart);
        }

        public reflow() {
            this.chart.reflow();
        }

        public addSeries(definition: ChartSeriesDefinition) {
            this.chart.addSeries(definition);
            this.chart.redraw();
        }

        public addAxis(definition: any) {
            this.chart.addAxis(definition);
        }
    }


    export class ColumnChart extends Chart {
        constructor(definition: ChartDefinition) {
            console.log('definition',definition);
            super(definition, 'column');
        }
    }

    export class LineChart extends Chart {
        constructor(definition: ChartDefinition, rounded: boolean = true) {
           
            super(definition, rounded ? 'spline' : 'line');
        }
    }

    export class AreaChart extends Chart {
        constructor(definition: ChartDefinition, stack: boolean = true) {
            super(definition, 'area');
            this.stackArea = stack;
            console.log('stack',stack);
        }
    }

    export class PercentageAreaChart extends Chart {
        constructor(definition: ChartDefinition, rounded: boolean = true) {
            super(definition, 'area');
        }
    }


    export class StockChartDefinition {
        public identifier: string;

        public showLegend?: boolean;
        public showRangeSelector?: boolean;

        public series?: Array<ChartSeriesDefinition>;
        public rangeInSeconds?: number;
    }

    export class UpdateStockChartDefinition {

        public series?: Array<ChartSeriesDefinition>;
        public rangeInSeconds?: number;
    }

    export class StockChart {


        public logger: Logger;

        private chart: any;
        private isInitialized: boolean = false;

        constructor(public definition: StockChartDefinition) {
            this.logger = new Logger(this);
        }

        public update(definition: UpdateStockChartDefinition) {

            var updateObject: any = {};

            if (definition.series) {
                updateObject.series = definition.series;

                while (this.chart.series.length > 0) {
                    this.chart.series[0].remove(false);
                }

                for (var series of definition.series) {
                    let seriesCopy = series;
                    this.chart.addSeries(seriesCopy, false);
                }
            }

           


            this.chart.redraw();
        }

        public initIfNecessary() {
            if (!this.isInitialized) {
                this.init();
            }
        }

        public init(): void {
            var global: any = window;

            if ($(this.definition.identifier).length == 0) {
                this.logger.error(`Element with identifier '${this.definition.identifier}' does not exits.`);
                return;
            }

            var firstChartColor = Utils.hexToRgb(jsData.generals.companyInformations.chartColors[0]);

            this.chart = global.Highcharts.stockChart({
                chart: {
                    renderTo: $(this.definition.identifier)[0],
                    type: 'areaspline'
                },
                rangeSelector: {
                    selected: 2,
                    buttons: [{
                        type: 'month',
                        count: 3,
                        text: '3M'
                    }, {
                        type: 'month',
                        count: 6,
                        text: '6M'
                        },
                        {
                        type: 'year',
                        count: 1,
                        text: '1J'
                    }, {
                        type: 'all',
                        text: 'Alles'
                        }],
                    inputEnabled: false,
                    enabled: this.definition.showRangeSelector != null ? this.definition.showRangeSelector : true
                },
                plotOptions: {
                    series: {
                       // compare: 'percent',
                        showInNavigator: true,
                        fillOpacity: 0.1
                    }
                },
                scrollbar: {
                    enabled: false
                },
                title: { text: '' },
                series: this.definition.series ? this.definition.series : [],
                legend: {
                    enabled: this.definition.showLegend != null ? this.definition.showLegend : false
                },
                credits: { enabled: false },
                navigator:
                {
                    height: 90,
                    maskFill: `rgba(${firstChartColor.r}, ${firstChartColor.g}, ${firstChartColor.b}, 0.1)`
                },
                xAxis: {
                    range: 1 * 30 * 24 * 3600 * 1000 // one months
                }
            });

            this.isInitialized = true;
        }

        public reflow() {
            this.chart.reflow();
        }

    }
}



var utils = UnitedOne.Utils;
// declare var site, $: any;


declare global {
    interface Date {
        removeTime(): this;
        toTimestamp(): number;
        toShortDateString(): string;
        toShortTimeString(): string;
        format(formatstring: string): string;
        clone(): Date;
        addDays(days: number): void;
        addMonth(month: number): void;
        getMonday(): Date;
        getNumberOfWeek(): number;
    }

    interface Number {
        toDate(): Date;
    }

    interface String {
        endsWith(searchString: string, position?: number);
        startsWith(searchString: string, position?: number);
        cut(maxLength: number);
        getBest(maxLength?: number, doNotCut?: boolean, seperator?: string);
    }

    interface Array<T> {
        first(filter?: (item: T) => boolean): T,
        last(filter?: (item: T) => boolean): T,
        select(selector: (item: T, index?:number) => any): any,
        where(filter: (item: T) => boolean): Array<T>,
        distinct(selector?: (item: T) => any): Array<T>,
        orderBy(clause: (item: T) => number, descending?: boolean): Array<T>,
        orderByDescending(clause: (item: T) => number): Array<T>,
        any(filter: (item: T) => boolean): boolean,
        all(filter: (item: T) => boolean): boolean,
        sum(filter: (item: T) => number): number,
        min(filter?: (item: T) => number): number,
        max(filter?: (item: T) => number): number,
        contains(item: T): boolean,
        remove(item: T): boolean,
        trend(item: T): number,
        take(count: number): Array<T>,
        skip(count: number): Array<T>,
    }
}

Date.prototype.removeTime = function () {
    this.setHours(0, 0, 0, 0);
    return this;
};

Date.prototype.toTimestamp = function () {
    return Math.round(this / 1000);
};


Date.prototype.toShortDateString = function () {
    var day = this.getDate();
    day = (day < 10 ? '0' : '') + day;

    var month = this.getMonth() + 1;
    month = (month < 10 ? '0' : '') + month;

    return day + '.' + month + '.' + this.getFullYear();
};

Date.prototype.toShortTimeString = function () {
    var minutes = this.getMinutes();
    minutes = (minutes < 10 ? '0' : '') + minutes;

    var hours = this.getHours();
    hours = (hours < 10 ? '0' : '') + hours;

    return hours + ':' + minutes;
};


Date.prototype.format = function (formatstring) {
    formatstring = formatstring.replace('{d}', this.toShortDateString());
    formatstring = formatstring.replace('{t}', this.toShortTimeString());
    return formatstring;
};

Date.prototype.clone = function () {
    return new Date(this.getTime());
};

Date.prototype.addDays = function (days) {
    this.setDate(this.getDate() + days);
};

Date.prototype.addMonth = function (month) {
    this.setMonth(this.getMonth() + month);
};


Date.prototype.getMonday = function () {
    var d = new Date(this.valueOf());
    var day = d.getDay();
    var diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    d.setDate(diff)
    d.setHours(0, 0, 0, 0);

    return new Date(d.valueOf());
};

Date.prototype.getNumberOfWeek = function () {
    var KWDatum = this;
    var DonnerstagDat = new Date(KWDatum.getTime() + (3 - ((KWDatum.getDay() + 6) % 7)) * 86400000);
    var KWJahr = DonnerstagDat.getFullYear();
    var DonnerstagKW = new Date(new Date(KWJahr, 0, 4).getTime() + (3 - ((new Date(KWJahr, 0, 4).getDay() + 6) % 7)) * 86400000);
    var KW = Math.floor(1.5 + (DonnerstagDat.getTime() - DonnerstagKW.getTime()) / 86400000 / 7);
    return KW;
};


Number.prototype.toDate = function () {
    return new Date(this);
};

Number.prototype.toDate = function () {
    return new Date(this);
};

Array.prototype.first = function (filter) {
    if (filter == null) {
        return this[0];
    }

    var result = null;
    $(this).each(function (index, item) {

        if (filter(item)) {
            result = item;
            return false;
        }
    });
    return result;
};

Array.prototype.last = function (filter) {
    if (filter == null) {
        return this[this.length - 1];
    }

    var result = null;
    $(this).each(function (index, item) {

        if (filter(item)) {
            result = item;
        }
    });
    return result;
};


Array.prototype.select = function (selector) {
    var result = [];
    $(this).each(function (index, item) {
        result.push(selector(item, index));
    });
    return result;
};

Array.prototype.where = function (filter) {
    var result = [];
    $(this).each(function (index, item) {
        if (filter(item)) {
            result.push(item);
        }
    });
    return result;
};

Array.prototype.orderByDescending = function (clause) {
    return this.orderBy(clause, true);
};

Array.prototype.orderBy = function (clause, descending) {

    if (descending == null) {
        descending = false;
    }

    var result = [];
    for (var i = 0; i < this.length; i++) {
        result[result.length] = this[i];
    }

    if (descending) {
        return result.sort(function (a, b) {
            var y = clause.apply(a, [a]), x = clause.apply(b, [b]);
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    else {
        return result.sort(function (a, b) {
            var x = clause.apply(a, [a]), y = clause.apply(b, [b]);
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
};



Array.prototype.distinct = function (selector) {

    if (selector == null) {
        selector = x => x;
    }

    var result = [];
    var distinctValues = [];
    $(this).each(function (index, item) {
        let distinctValue = selector(item);
        if (!distinctValues.contains(distinctValue)) {
            distinctValues.push(distinctValue);
            result.push(item);
        }
    });
    return result;
};

Array.prototype.any = function (filter) {
    if (filter == null) {
        return this.length > 0;
    }
    else {
        var result = false;
        $(this).each(function (index, item) {
            if (filter(item)) {
                result = true;
                return false;
            }
        });

        return result;
    }
};

Array.prototype.all = function (filter) {
    if (filter == null) {
        return this.length > 0;
    }
    else {
        var result = true;
        $(this).each(function (index, item) {
            if (!filter(item)) {
                result = false;
            }
        });
        return result;
    }
};

Array.prototype.contains = function (item) {
    return this.indexOf(item) != -1;
};

Array.prototype.remove = function (item) {
    var index = this.indexOf(item);
    if (index > -1) {
        this.splice(index, 1);
        return true;
    }

    return false;
};

Array.prototype.sum = function (filter) {
    if (filter == null) {
        return 0;
    }
    else {
        var result = 0;
        $(this).each(function (index, item) {
            result += filter(item);
        });

        return result;
    }
};

Array.prototype.min = function (filter?) {
    if (filter == null) {
        filter = (x) => x;
    }

    if (this.length == 0) {
        return 0;
    }

    var result = Number.MAX_VALUE;

    $(this).each(function (index, item) {
        var value = filter(item);
        if (value < result) {
            result = value;
        }
    });

    return result;
};

Array.prototype.max = function (filter?) {
    if (filter == null) {
        filter = (x) => x;
    }

    if (this.length == 0) {
        return 0;
    }

    var result = Number.MIN_VALUE;

    $(this).each(function (index, item) {
        var value = filter(item);
        if (value > result) {
            result = value;
        }
    });

    return result;
};


Array.prototype.skip = function (count) {
    return this.slice(count);
};

Array.prototype.take = function (count) {
    return this.slice(0, count);
};



String.prototype.cut = function (maxLength) {
    if (this.length <= maxLength) {
        return this;
    }

    return this.substr(0, maxLength - 3) + ' ... ';
};

String.prototype.getBest = function (maxLength, doNotCut, seperator) {

    if (seperator == null) {
        seperator = '|';
    }

    if (maxLength == null) {
        maxLength = Number.MAX_VALUE;
    }

    if (doNotCut == null) {
        doNotCut = false;
    }


    var parts = this.split(seperator);

    parts.sort(function (a, b) {
        return b.length - a.length;
    });

    var i = 0;

    while ((parts[i].length > maxLength) && (i < (parts.length - 1))) {
        i++;
    }


    if (parts[i].length <= maxLength) {
        return parts[i];
    }

    if (doNotCut) {
        return parts[i];
    }

    return parts[i].substr(0, maxLength - 3) + '... ';    
};


// Polyfills
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.indexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

export { };

declare var services: any;

// Wrapper for old style site-syntax
var site = {
    showConfirmDialog: (message: string, callback: (result: boolean) => void) => {
        //console.log(title);
        services.dialogs.confirm(message, callback);
    },

    closeDialog: () => { services.dialogs.alert('Die Verwendung von site.closeDialog() ist veraltet.'); },
    showAlertDialog: (message: string) => { services.dialogs.alert(message); }
}
